/**
 * AttributeConditionType - Condition qui vérifie si un attribut existe
 * Identique à Flutter AttributeConditionType
 */

import {ConditionType} from '../types/ConditionType';
import {GameState} from '../../../models/GameState';
import {PlayerStep} from '../../../models/PlayerStep';
import GameStateHelper from '../../../helpers/GameStateHelper';

export class AttributeConditionType implements ConditionType {
  typeName = 'COND_ATTRIBUTE';
  messageKey = 'laventurier.condition.attribute.name';
  descriptionKey = 'laventurier.condition.attribute.desc';
  errorKey = 'laventurier.condition.attribute.error';
  hasValue = false;
  hasAttribute = true;

  evaluate(gameState: GameState, condition: any): boolean {
    const attributeId = condition.attribute || condition.attributeId;
    if (!attributeId) {
      console.log('[AttributeConditionType] FALSE: no attribute specified');
      return false;
    }

    const searchedAttrId = attributeId.toString();

    // Vérifier dans objects (avec champ 'dropped')
    for (const obj of gameState.data.objects) {
      if (obj.attributeId.toString() === searchedAttrId && obj.dropped === 0) {
        console.log(`[AttributeConditionType] TRUE: Found attributeId=${searchedAttrId} in objects`);
        return true;
      }
    }

    // Vérifier dans skills
    for (const skill of gameState.data.skills) {
      if (skill.attributeId.toString() === searchedAttrId) {
        console.log(`[AttributeConditionType] TRUE: Found attributeId=${searchedAttrId} in skills`);
        return true;
      }
    }

    // Vérifier dans butterflyEffects
    for (const effect of gameState.data.butterflyEffects) {
      if (effect.attributeId.toString() === searchedAttrId) {
        console.log(`[AttributeConditionType] TRUE: Found attributeId=${searchedAttrId} in butterflyEffects`);
        return true;
      }
    }

    console.log(`[AttributeConditionType] FALSE: attributeId=${searchedAttrId} not found`);
    return false;
  }
}
